import React from "react";
import clsx from "clsx";
import Icon from "../../../../../../components/Icon";
import { TiCardDetectedSamplesData } from "../../../../@types";
import PostfixNumber from "../PostfixNumber";
import { RenderWhen } from "../../../../../../components";

interface Props {
  detectedSamplesData: TiCardDetectedSamplesData;
}

const TiCardDetectedSamples = ({ detectedSamplesData }: Props) => {
  const detectedSamplesDelta =
    detectedSamplesData.current_week - detectedSamplesData.last_week;
  let detectedSamplesIcon = "empty";
  let detectedSamplesIconColorClass = "";
  if (detectedSamplesDelta > 0) {
    detectedSamplesIcon = "trending-up";
    detectedSamplesIconColorClass = "icon__up";
  } else if (detectedSamplesDelta < 0) {
    detectedSamplesIcon = "trending-down";
    detectedSamplesIconColorClass = "icon__down";
  }

  return (
    <>
      <RenderWhen condition={detectedSamplesIcon !== "empty"}>
        <Icon
          className={clsx(
            detectedSamplesIconColorClass,
            "k-pdf-icon-right-margin"
          )}
          name={detectedSamplesIcon}
        />
      </RenderWhen>
      <PostfixNumber number={detectedSamplesData.current_week} />
    </>
  );
};

export default TiCardDetectedSamples;
